import { render, staticRenderFns } from "./ContactInfoBox.vue?vue&type=template&id=7709d4de&scoped=true"
import script from "./ContactInfoBox.vue?vue&type=script&lang=js"
export * from "./ContactInfoBox.vue?vue&type=script&lang=js"
import style0 from "./ContactInfoBox.vue?vue&type=style&index=0&id=7709d4de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7709d4de",
  null
  
)

export default component.exports